module.exports = __webpack_public_path__ + "img/icn-guides.40ca0ccf.svg";